import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { errorHandling } from './errorHandling';

const LazyLoader = React.lazy(() => import('Ui/Loader').catch(errorHandling));

const LoaderLoader = () => (
    <ErrorBoundary fallback={<div></div>}>
        <Suspense fallback={<div></div>}>
            <LazyLoader />
        </Suspense>
    </ErrorBoundary>
);

export default LoaderLoader;
